
    <div *ngIf="entity">
      <firmware-link-widget
        [entity]="entity"
        [layout]="'full'"
        [options]="{}"
      ></firmware-link-widget>
    </div>
  